"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentButton = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const Button_1 = require("../Button");
exports.SegmentButton = (0, styled_1.default)(Button_1.Button) `
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  &:focus,
  &:hover {
    z-index: 2;
    outline-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    outline-width: 2px;
    outline-style: solid;
    outline-offset: -3px;
    background-color: ${(0, ui_theme_1.fromTheme)('color_item_hover')};
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
  }
  &[aria-pressed='true'] {
    z-index: 1;
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_secondary_hover')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_border_secondary')};
    &:focus {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_secondary_hover')};
    }
  }
`;
//# sourceMappingURL=SegmentedButton.styles.js.map